import asyncComponent from 'components/Router/AsyncComponent';
export default asyncComponent(() => import('./container'));
